<template>
  <div id="jushuitanExam">
    <div class="exam-layout">
      <aside class="chapter-nav">
        <div v-for="chapter in chapters" :key="chapter.key" :class="['chapter-item', { active: tabCurrent === chapter.key }]">
          <p>{{ chapter.title }}</p>
        </div>
      </aside>

      <main class="exam-main">
        <div v-show="state.practiceVisible" class="content">
          <div class="con-left">
            <JstErpLoginScene
              v-if="tabCurrent === 'first'"
              ref="scene-first"
              @step-change="onStepChange"
              @guard-failed="onGuardFailed"
              @finish="onFinish"
            />
            <JstErpSecondScene
              v-else-if="tabCurrent === 'second'"
              ref="scene-second"
              @step-change="onStepChange"
              @guard-failed="onGuardFailed"
              @finish="onFinish"
            />
            <JstErpCreateAftersaleScene
              v-else-if="tabCurrent === 'third'"
              ref="scene-third"
              @step-change="onStepChange"
              @guard-failed="onGuardFailed"
              @finish="onFinish"
            />
            <JstErpOrderQueryScene
              v-else
              ref="scene-four"
              @step-change="onStepChange"
              @guard-failed="onGuardFailed"
              @finish="onFinish"
            />
          </div>
          <aside class="con-right">
            <h3><span class="line"></span>提示</h3>
            <div :class="{ 'compact-tip': tabCurrent === 'third' && rightTipStep === 'create-wrong-exchange' }" v-html="rightTip"></div>
          </aside>
        </div>

        <div v-if="!state.practiceVisible || state.practiceCompleted" class="stoptip">
          <div class="tip">
            <span v-if="state.practiceCompleted" class="el-icon-success"></span>
            <p v-if="state.practiceCompleted">{{ isLastChapter ? '聚水潭实操完成' : '实操通关，进入下一关吧' }}</p>
            <p v-if="!state.practiceVisible">
              <a class="startstudy" @click="startStudy">开始实操练习</a>
            </p>
            <p v-else-if="isLastChapter">
              <a class="restart" @click="restartStudy"><i class="el-icon-refresh-left"></i>重练</a>
            </p>
            <p v-else>
              <a class="restart" @click="restartStudy"><i class="el-icon-refresh-left"></i>重练</a>
              <a class="startstudy" @click="studyNext">GO，下一关</a>
            </p>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import JstErpLoginScene from './jushuitan/JstErpLoginScene.vue'
import JstErpSecondScene from './jushuitan/JstErpSecondScene.vue'
import JstErpCreateAftersaleScene from './jushuitan/JstErpCreateAftersaleScene.vue'
import JstErpOrderQueryScene from './jushuitan/JstErpOrderQueryScene.vue'

const CHAPTERS = [
  { key: 'first', title: '1、登记无条件信息' },
  { key: 'second', title: '2、手工创建售后单' },
  { key: 'third', title: '3、创建售后' },
  { key: 'four', title: '4、订单查询' }
]

export default {
  name: 'JuShuiTanErpExam',
  components: { JstErpLoginScene, JstErpSecondScene, JstErpCreateAftersaleScene, JstErpOrderQueryScene },
  data() {
    return {
      chapters: CHAPTERS,
      tabCurrent: 'first',
      rightTip: '',
      rightTipStep: '',
      finishTimer: null,
      state: {
        practiceVisible: false,
        practiceCompleted: false
      }
    }
  },
  computed: {
    isLastChapter() {
      return this.tabCurrent === this.chapters[this.chapters.length - 1].key
    }
  },
  beforeDestroy() {
    this.clearFinishTimer()
  },
  methods: {
    getCurrentScene() {
      const scene = this.$refs['scene-' + this.tabCurrent]
      return Array.isArray(scene) ? scene[0] : scene
    },
    startStudy() {
      this.clearFinishTimer()
      this.state.practiceVisible = true
      this.state.practiceCompleted = false
      this.rightTip = ''
      this.rightTipStep = ''
      this.addRecord('START')
      this.$nextTick(() => {
        const scene = this.getCurrentScene()
        if (scene && scene.reset) scene.reset()
      })
    },
    restartStudy() {
      this.clearFinishTimer()
      this.state.practiceCompleted = false
      this.rightTip = ''
      this.rightTipStep = ''
      this.addRecord('START')
      this.$nextTick(() => {
        const scene = this.getCurrentScene()
        if (scene && scene.reset) scene.reset()
      })
    },
    studyNext() {
      const currentIndex = this.chapters.findIndex(chapter => chapter.key === this.tabCurrent)
      const nextChapter = this.chapters[currentIndex + 1]
      if (!nextChapter) return
      this.clearFinishTimer()
      this.tabCurrent = nextChapter.key
      this.state.practiceCompleted = false
      this.rightTip = ''
      this.rightTipStep = ''
      this.addRecord('START')
      this.$nextTick(() => {
        const scene = this.getCurrentScene()
        if (scene && scene.reset) scene.reset()
      })
    },
    onStepChange(stepId, step, tip) {
      this.rightTipStep = stepId
      this.rightTip = tip || ''
    },
    onGuardFailed(res) {
      this.$alert(res && res.msg ? res.msg : '校验未通过')
    },
    onFinish() {
      this.addRecord('END', this.isLastChapter ? this.finishExam : null)
      this.clearFinishTimer()
      this.finishTimer = setTimeout(() => {
        this.finishTimer = null
        this.state.practiceCompleted = true
      }, 2000)
    },
    clearFinishTimer() {
      if (!this.finishTimer) return
      clearTimeout(this.finishTimer)
      this.finishTimer = null
    },
    finishExam() {
      this.addCourseRecord()
      if (window.parent && typeof window.parent.goBack === 'function') {
        window.parent.goBack()
      }
    },
    addCourseRecord() {
      const courseId = this.$route.query.courseId
      if (!courseId) return
      this.$http.post(API_ROOT.college + '/courseRecord/tool/addCourseRecord?courseId=' + encodeURIComponent(courseId), null).then(() => {})
    },
    addRecord(exerciseAction, onSuccess) {
      const stepSeq = this.chapters.findIndex(chapter => chapter.key === this.tabCurrent) + 1
      const data = {
        exerciseType: 'WORKORDER_JUSHUITAN_EXAM',
        stepSeq,
        exerciseAction
      }
      this.$http.post(API_ROOT.newcustomer + '/simulationExercise/addRecord', data).then(res => {
        const result = res.data
        if (result && result.success) {
          if (onSuccess) onSuccess()
        } else {
          this.$message({ message: (result && result.msg) || '记录练习进度失败', type: 'error', center: true, duration: 1000 })
        }
      }, () => {
        this.$message({ message: '网络繁忙，请稍后重试！', type: 'error', center: true, duration: 1000 })
      })
    }
  }
}
</script>

<style lang="less" scoped>
#jushuitanExam { box-sizing: border-box; min-height: 100vh; padding: 10px; color: #454545; background: #f1f5f8; }
.exam-layout { display: flex; min-height: calc(100vh - 20px); }
.chapter-nav { flex: 0 0 180px; margin-right: 10px; background: #fff; }
.chapter-item { box-sizing: border-box; min-height: 54px; padding: 10px; color: #454545; cursor: default; }
.chapter-item p { margin: 0; line-height: 34px; text-align: left; }
.chapter-item.active { color: #fff; background: #4c75f1; }
.exam-main { position: relative; flex: 1 1 auto; min-width: 0; background: #fff; }
.content { display: flex; min-height: calc(100vh - 20px); color: #2b2b2b; background: #f1f5f8; }
.con-left { flex: 1 1 auto; min-width: 0; overflow: auto; background: #fff; }
.con-right { flex: 0 0 170px; box-sizing: border-box; min-width: 0; min-height: calc(100vh - 20px); padding: 10px; margin-left: 10px; overflow: auto; font-size: 14px; line-height: 26px; overflow-wrap: anywhere; word-break: break-all; background: #fff; }
.con-right .compact-tip { font-size: 12px; line-height: 20px; }
.con-right h3 { margin: 0 0 12px; font-size: 16px; }
.con-right p { margin: 0 0 8px; }
.con-right /deep/ * { box-sizing: border-box; max-width: 100%; }
.line { display: inline-block; width: 4px; height: 20px; margin-right: 2px; vertical-align: text-bottom; background: #4c75f1; }
.stoptip { position: absolute; z-index: 10; top: 0; right: 0; bottom: 0; left: 0; display: flex; align-items: center; justify-content: center; color: #2b2b2b; text-align: center; background: rgba(127, 127, 127, .5); }
.tip { box-sizing: border-box; width: 360px; min-height: 220px; padding: 48px 26px; font-size: 16px; font-weight: bold; background: #fff; border-radius: 5px; }
.tip > p { margin: 15px 0; }
.tip > .el-icon-success { color: #3fde3f; font-size: 40px; }
.startstudy, .restart { display: inline-block; box-sizing: border-box; width: 130px; height: 38px; color: #fff; line-height: 36px; background: #4c75f1; border: 1px solid #4c75f1; cursor: pointer; }
.restart { margin-right: 5px; color: #4c75f1; background: #fff; }
.restart .el-icon-refresh-left { padding-right: 5px; font-size: 20px; vertical-align: -2px; }
@media (max-width: 860px) { #jushuitanExam { min-width: 760px; } }
</style>



// WEBPACK FOOTER //
// ./src/page/simulate/juShuiTanErpExam.vue